'use client'
import { Dictionary } from '@/localization/dictionary'
import { useEffect, useState } from 'react'

const DAY = 1000 * 60 * 60 * 24
const HOUR = 1000 * 60 * 60
const MINUTE = 1000 * 60
const SECOND = 1000

interface CountdownProps {
  endTime: string
  dict: Dictionary['components']['countdown']
}

const getRemainingTime = (endTime: string) => {
  const now = new Date().getTime()
  const targetTime = new Date(endTime).getTime()
  const timeDifference = targetTime - now

  if (timeDifference > 0) {
    const days = Math.floor(timeDifference / DAY)
    const hours = Math.floor((timeDifference % DAY) / HOUR)
    const minutes = Math.floor((timeDifference % HOUR) / MINUTE)
    const seconds = Math.floor((timeDifference % MINUTE) / SECOND)

    return {
      timeLeft: timeDifference,
      days: leadingZero(days),
      hours: leadingZero(hours),
      minutes: leadingZero(minutes),
      seconds: leadingZero(seconds),
    }
  }

  return {
    timeLeft: 0,
    days: '',
    hours: '',
    minutes: '',
    seconds: '',
  }
}

const leadingZero = (number: number) =>
  number < 10 && number > -10 ? `${0}${number}` : String(number)

const Countdown = ({ endTime, dict }: CountdownProps) => {
  const [remainingTime, setRemainingTime] = useState(() =>
    getRemainingTime(endTime),
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = getRemainingTime(endTime)

      if (remainingTime.timeLeft <= 0) {
        clearInterval(interval)
      }

      setRemainingTime(remainingTime)
    }, SECOND)

    return () => {
      clearInterval(interval)
    }
  }, [endTime])

  return (
    <>
      <span className="flex gap-1 sm:gap-2">
        <span className="relative">
          <span suppressHydrationWarning className="absolute">
            {remainingTime.days}
          </span>
          <span className="invisible mr-0.5">88</span>
        </span>
        <span className="font-light">{dict.days}</span>
      </span>
      <span className="flex gap-1 sm:gap-2">
        <span className="relative">
          <span suppressHydrationWarning className="absolute">
            {remainingTime.hours}
          </span>
          <span className="invisible mr-0.5">88</span>
        </span>
        <span className="font-light">{dict.hours}</span>
      </span>
      <span className="flex gap-1 sm:gap-2">
        <span className="relative">
          <span suppressHydrationWarning className="absolute">
            {remainingTime.minutes}
          </span>
          <span className="invisible mr-0.5">88</span>
        </span>
        <span className="font-light">{dict.minutes}</span>
      </span>
      <span className="flex gap-1 sm:gap-2">
        <span className="relative">
          <span suppressHydrationWarning className="absolute">
            {remainingTime.seconds}
          </span>
          <span className="invisible mr-0.5">88</span>
        </span>
        <span className="font-light">{dict.seconds}</span>
      </span>
    </>
  )
}

export default Countdown
